import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from '@azure/msal-browser';
import { WorkInProgressComponent } from './shared/components/work-in-progress/work-in-progress.component';
import { GlobalSearchResultComponent } from './core/components/global-search-result/global-search-result.component';
import { DashboardComponent } from './core/components/dashboard/dashboard.component';
import { FailedComponent } from './core/components/failed/failed.component';
import { AdminRoutesEnum, RoutesEnum, SupportRoutes } from './core/enums/routes.enum';
import { paginationInitResolver } from './core/resolvers/pagination.resolver';

const appRoutes: Routes = [
  {
    path: AdminRoutesEnum.Admin,
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: SupportRoutes.LoginFailed,
    component: FailedComponent,
  },
  {
    path: `${SupportRoutes.GlobalSearchResult}`,
    component: GlobalSearchResultComponent,
  },
  {
    path: RoutesEnum.Documents,
    loadChildren: () =>
      import('./document-user/document-user.module').then((m) => m.DocumentUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Certificate,
    loadChildren: () =>
      import('./certificate-user/certificate-user.module').then((m) => m.CertificateUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.NonConformance,
    loadChildren: () =>
      import('./non-conformance-user/non-conformance-user.module').then(
        (m) => m.NonConformanceUserModule
      ),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.RiskAssessments,
    loadChildren: () =>
      import('./risk-assessment-user/risk-assessment-user.module').then(
        (m) => m.RiskAssessmentUserModule
      ),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Purchase,
    loadChildren: () => import('./order-user/order-user.module').then((m) => m.OrderUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Audits,
    loadChildren: () => import('./audit-user/audit-user.module').then((m) => m.AuditUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Storage,
    loadChildren: () =>
      import('./storage-user/storage-user.module').then((m) => m.StorageUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Medicines,
    loadChildren: () =>
      import('./medicine-user/medicine-user.module').then((m) => m.MedicineUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Drills,
    loadChildren: () => import('./drills-user/drills-user.module').then((m) => m.DrillsUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Checklists,
    loadChildren: () => import('./task-user/task-user.module').then((m) => m.TaskUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Responses,
    loadChildren: () =>
      import('./shared/custom-forms-responses/custom-forms-responses.module').then(
        (m) => m.CustomFormsResponsesModule
      ),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Maintenance,
    loadChildren: () =>
      import('./maintenance-user/maintenance-user.module').then((m) => m.MaintenanceUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.ShiftAndManning,
    loadChildren: () =>
      import('./crew-management-user/crew-management-user.module').then(
        (m) => m.CrewManagementUserModule
      ),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: AdminRoutesEnum.Users,
    loadChildren: () => import('./user/user.module').then((m) => m.UserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.WorkAndRest,
    loadChildren: () =>
      import('./work-and-rest-user/work-and-rest-user.module').then((m) => m.WorkAndRestUserModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: RoutesEnum.Profile,
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: '',
    component: DashboardComponent,
  },
  {
    path: RoutesEnum.RunTime,
    loadChildren: () => import('./run-time/run-time.module').then((m) => m.RunTimeModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: 'due-list',
    loadChildren: () => import('./due-list/due-list.module').then((m) => m.DueListModule),
    resolve: { paginationInit: paginationInitResolver },
  },
  {
    path: '**',
    component: WorkInProgressComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      // Don't perform initial navigation in iframes or popups
      // should be 'enabledBlocking' for Angular Universal but we're not using it rn and it's causing issues with breadcrumbs on reload
      // https://github.com/udayvunnam/xng-breadcrumb/issues/108
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled', // Remove this line to use Angular Universal
      preloadingStrategy: NoPreloading,
    }),
  ],

  exports: [RouterModule],
})
export class AppRoutingModule {}
